import { useMutation, useQueryClient } from '@tanstack/react-query';

import { useQueryKeys } from '@/shared/hooks/use-query-keys';
import { useWorkspaceId } from '@/shared/hooks/use-workspace-id';
import { trackEvent } from '@/shared/track';
import { ExcludeCreators, UnExcludeCreators } from '../api';

export const useExcludeCreator = () => {
  const { workspaceId } = useWorkspaceId();
  const queryClient = useQueryClient();
  const queryKeys = useQueryKeys();

  return useMutation({
    mutationFn: (creatorId: string) =>
      ExcludeCreators({
        workspace_id: workspaceId,
        creator_id: creatorId,
      }),
    onSuccess: (data) => {
      trackEvent('Exclude_list', 'add_exclude', {
        creator_id: data.creator_id,
      });
      queryClient.invalidateQueries({ queryKey: queryKeys.excludeList.all() });
    },
  });
};

export const useUnExcludeCreator = () => {
  const { workspaceId } = useWorkspaceId();
  const queryClient = useQueryClient();
  const queryKeys = useQueryKeys();

  return useMutation({
    mutationFn: (creatorId: string) =>
      UnExcludeCreators({
        workspace_id: workspaceId,
        creator_id: creatorId,
      }),
    onSuccess: (data) => {
      trackEvent('Exclude_list', 'remove_exclude', {
        creator_id: data.creator_id,
      });
      queryClient.invalidateQueries({ queryKey: queryKeys.excludeList.all() });
    },
  });
};
